// extracted by mini-css-extract-plugin
export default {"wrapper":"q0BfVyAkoPeni9PS2ebB"};